import { createReducer, requestStatus } from '../../lib/Utils'
import {
  CLEAR_AD_CAMPAIGN,
  GET_PAID_ADS,
  GET_PAID_ADS_FULFILLED,
  GET_PAID_ADS_REJECTED,
  CREATE_AD_CAMPAIGN,
  CREATE_AD_CAMPAIGN_FULFILLED,
  CREATE_AD_CAMPAIGN_REJECTED,
  UPDATE_AD_CAMPAIGN,
  UPDATE_AD_CAMPAIGN_FULFILLED,
  UPDATE_AD_CAMPAIGN_REJECTED,
  GET_AD_CAMPAIGN,
  GET_AD_CAMPAIGN_FULFILLED,
  GET_AD_CAMPAIGN_REJECTED,
  POST_AD_CAMPAIGN_INVITATIONS,
  POST_AD_CAMPAIGN_INVITATIONS_FULFILLED,
  POST_AD_CAMPAIGN_INVITATIONS_REJECTED,
  PUBLISH_AD_CAMPAIGN,
  PUBLISH_AD_CAMPAIGN_FULFILLED,
  PUBLISH_AD_CAMPAIGN_REJECTED,
  DELETE_AD_CAMPAIGN_INVITATIONS,
  DELETE_AD_CAMPAIGN_INVITATIONS_FULFILLED,
  DELETE_AD_CAMPAIGN_INVITATIONS_REJECTED,
  DELETE_AD_CAMPAIGN_FULFILLED,
} from './actions'
import { ACTIVATE_CAMPAIGN_FULFILLED } from '../facebook-ads/actions'

const initialState = {}

export const GENERIC_ERROR_MSG = 'Request failed'

export default createReducer(initialState, {
  [CLEAR_AD_CAMPAIGN]: (state) => {
    return {
      ...state,
      adCampaignData: null,
      getAdCampaignStatus: null,
      createAdCampaignStatus: null,
      createAdCampaignErrors: null,
      publishAdCampaignStatus: null,
      publishAdCampaignErrors: null,
      postAdCampaignInvitationsStatus: null,
      postAdCampaignInvitationsErrors: null,
    }
  },
  [ACTIVATE_CAMPAIGN_FULFILLED]: (state, action) => {
    const campaignId = action.payload.campaignId

    const paidAds = [...state.paidAds]
    paidAds.forEach((paidAd) => {
      if (campaignId === paidAd.id) {
        paidAd.campaign_invitation = {
          ...paidAd.campaign_invitation,
          state: 'pending',
        }
      }
    })

    const paidAdsById = { ...state.paidAdsById }
    if (paidAdsById[campaignId]) {
      paidAdsById[campaignId].campaign_invitation = {
        ...paidAdsById[campaignId].campaign_invitation,
        state: 'pending',
      }
    }

    const newState = {
      ...state,
      paidAds,
      paidAdsById,
    }
    return newState
  },
  [GET_PAID_ADS]: (state) => {
    return {
      ...state,
      paidAdsStatus: requestStatus.pending,
      paidAdsErrors: null,
    }
  },
  [GET_PAID_ADS_FULFILLED]: (state, action) => {
    const paidAdsById = { ...state.paidAdsById }
    const paidAds = action.payload.data || action.payload
    paidAds.map((paidAd) => {
      paidAdsById[`${paidAd.id}`] = {
        ...paidAdsById[`${paidAd.id}`],
        ...paidAd,
      }
    })
    const newState = {
      ...state,
      paidAds,
      paidAdsById,
      paidAdsStatus: requestStatus.complete,
      paidAdsErrors: null,
    }
    return newState
  },
  [GET_PAID_ADS_REJECTED]: (state, action) => {
    let paidAdsErrors
    if (action.payload && action.payload.errors) {
      paidAdsErrors = action.payload.errors
    } else {
      paidAdsErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      paidAdsStatus: requestStatus.rejected,
      paidAds: [],
      paidAdsById: {},
      paidAdsErrors,
    }
    return newState
  },
  [CREATE_AD_CAMPAIGN]: (state) => {
    return {
      ...state,
      createAdCampaignStatus: requestStatus.pending,
      createAdCampaignErrors: null,
    }
  },
  [CREATE_AD_CAMPAIGN_FULFILLED]: (state) => {
    return {
      ...state,
      createAdCampaignStatus: requestStatus.complete,
      createAdCampaignErrors: null,
    }
  },
  [CREATE_AD_CAMPAIGN_REJECTED]: (state, action) => {
    let createAdCampaignErrors
    if (action.payload && action.payload.errors) {
      createAdCampaignErrors = action.payload.errors
    } else {
      createAdCampaignErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      createAdCampaignStatus: requestStatus.rejected,
      createAdCampaignErrors,
    }
    return newState
  },
  [UPDATE_AD_CAMPAIGN]: (state) => {
    return {
      ...state,
      updateAdCampaignStatus: requestStatus.pending,
      updateAdCampaignErrors: null,
    }
  },
  [UPDATE_AD_CAMPAIGN_FULFILLED]: (state) => {
    return {
      ...state,
      updateAdCampaignStatus: requestStatus.complete,
      updateAdCampaignErrors: null,
    }
  },
  [UPDATE_AD_CAMPAIGN_REJECTED]: (state, action) => {
    let updateAdCampaignErrors
    if (action.payload && action.payload.errors) {
      updateAdCampaignErrors = action.payload.errors
    } else {
      updateAdCampaignErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      updateAdCampaignStatus: requestStatus.rejected,
      updateAdCampaignErrors,
    }
    return newState
  },
  [DELETE_AD_CAMPAIGN_INVITATIONS]: (state) => {
    return {
      ...state,
      deleteAdCampaignInvitationsStatus: requestStatus.pending,
      deleteAdCampaignInvitationsErrors: null,
    }
  },
  [DELETE_AD_CAMPAIGN_INVITATIONS_FULFILLED]: (state) => {
    return {
      ...state,
      deleteAdCampaignInvitationsStatus: requestStatus.complete,
      deleteAdCampaignInvitationsErrors: null,
      adCampaignData: {
        ...state.adCampaignData,
        invitations: [],
      },
    }
  },
  [DELETE_AD_CAMPAIGN_INVITATIONS_REJECTED]: (state, action) => {
    let deleteAdCampaignInvitationsErrors
    if (action.payload && action.payload.errors) {
      deleteAdCampaignInvitationsErrors = action.payload.errors
    } else {
      deleteAdCampaignInvitationsErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      deleteAdCampaignInvitationsStatus: requestStatus.rejected,
      deleteAdCampaignInvitationsErrors,
    }
    return newState
  },
  [POST_AD_CAMPAIGN_INVITATIONS]: (state) => {
    return {
      ...state,
      postAdCampaignInvitationsStatus: requestStatus.pending,
      postAdCampaignInvitationsErrors: null,
    }
  },
  [POST_AD_CAMPAIGN_INVITATIONS_FULFILLED]: (state) => {
    return {
      ...state,
      postAdCampaignInvitationsStatus: requestStatus.complete,
      postAdCampaignInvitationsErrors: null,
    }
  },
  [POST_AD_CAMPAIGN_INVITATIONS_REJECTED]: (state, action) => {
    let postAdCampaignInvitationsErrors
    if (action.payload && action.payload.errors) {
      postAdCampaignInvitationsErrors = action.payload.errors
    } else {
      postAdCampaignInvitationsErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      postAdCampaignInvitationsStatus: requestStatus.rejected,
      postAdCampaignInvitationsErrors,
    }
    return newState
  },
  [PUBLISH_AD_CAMPAIGN]: (state) => {
    return {
      ...state,
      publishAdCampaignStatus: requestStatus.pending,
      publishAdCampaignErrors: null,
    }
  },
  [PUBLISH_AD_CAMPAIGN_FULFILLED]: (state) => {
    return {
      ...state,
      publishAdCampaignStatus: requestStatus.complete,
      publishAdCampaignErrors: null,
    }
  },
  [PUBLISH_AD_CAMPAIGN_REJECTED]: (state, action) => {
    let publishAdCampaignErrors
    if (action.payload && action.payload.errors) {
      publishAdCampaignErrors = action.payload.errors
    } else {
      publishAdCampaignErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      publishAdCampaignStatus: requestStatus.rejected,
      publishAdCampaignErrors,
    }
    return newState
  },
  [GET_AD_CAMPAIGN]: (state) => {
    return {
      ...state,
      getAdCampaignStatus: requestStatus.pending,
      getAdCampaignErrors: null,
    }
  },
  [GET_AD_CAMPAIGN_FULFILLED]: (state, action) => {
    return {
      ...state,
      getAdCampaignStatus: requestStatus.complete,
      getAdCampaignErrors: null,
      adCampaignData: { ...action.payload },
    }
  },
  [GET_AD_CAMPAIGN_REJECTED]: (state, action) => {
    let getAdCampaignErrors
    if (action.payload && action.payload.errors) {
      getAdCampaignErrors = action.payload.errors
    } else {
      getAdCampaignErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      getAdCampaignStatus: requestStatus.rejected,
      getAdCampaignErrors,
    }
    return newState
  },
  [DELETE_AD_CAMPAIGN_FULFILLED]: (state, action) => {
    const paidAds = [...(state.paidAds || [])]
    const id = action.meta.campaignId
    const index = paidAds.findIndex((paidAd) => paidAd.id === id)
    paidAds.splice(index, 1)
    const newState = { ...state, paidAds }
    return newState
  },
})
